module.exports = __webpack_public_path__ + "static/img/footer.2402cf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topImg/footer.jpg
// module id = o+P5
// module chunks = 9